import { static_img_url, LazyImage } from '../../base'

function Features() {
  return (
    <div className='features container' style={{ minHeight: '100vh' }}>

      {/* ocasion */}
      <div className='singleFeature row' style={{ alignItems: 'center' }}  >

        <div className='col-md-6'>
          <div className='h4 scolor text-center' style={{}}>Want to Shine on Every Occasion?</div>
          <div className='divider w-75' style={{ margin: 'auto' }}>*</div>
          <div className='h6 pcolor'>Drape Yourself in Maheshwari Elegance ~ " A Timeless Blend of Tradition and Grace. "</div>
          <div className='h6'>Maheshwari sarees and dupattas are more than just fabrics—they are a statement of grace and
            tradition. Whether for festivals, weddings, or special occasions, these handcrafted weaves make you
            stand out with heritage-rich elegance.</div>
        </div>
        <div className='col-md-6 text-center'>
          <div className='imgdiv first mt-4'>
            <LazyImage src={`${static_img_url}/features/occasion.webp`} alt={'Occasion'} />
          </div>
        </div>
      </div>
      <hr className='mt-5 mb-5' />

      {/* delivery */}
      <div className='singleFeature row' style={{ alignItems: 'center' }}  >

        <div className='col-md-6 text-center'>
          <div className='imgdiv second'>
            <LazyImage src={`${static_img_url}/features/delivery.webp`} alt={'delivery'} />
          </div>
        </div>
        <div className='col-md-6'>
          <div className='h4 scolor mb-3'>Bringing Maheshwari Heritage to Your Doorstep ~ " Free Delivery Across India on Each Product "</div>
          <div className='h6'>Now, order from anywhere, anytime—authentic handwoven Maheshwari sarees and dupattas at your fingertips. We bring tradition closer to you with fast, affordable delivery across India.</div>
        </div>
      </div>
      <hr className='mt-5 mb-5' />

      {/* category */}
      <div className='singleFeature row' style={{ alignItems: 'center' }}  >

        <div className='col-md-6'>
          <div className='h4 scolor mb-3'>From Royal Maheshwari Silk to Classic Bagh Prints – " A Handwoven Collection Crafted for Every Occasion."</div>
          <div className='h6'>Our collection features the finest Maheshwari weaves, including silk sarees, bagh print sarees, lightweight dupattas, and more. Every piece reflects the art, skill, and tradition of Maheshwar’s legendary weavers.</div>
        </div>
        <div className='col-md-6 text-center'>
          <div className='imgdiv third'>
            <LazyImage src={`${static_img_url}/features/category.webp`} alt={'Category'} />
          </div>
        </div>
      </div>
      <hr className='mt-5 mb-5' />

      {/* handloom */}
      <div className='singleFeature row' style={{ alignItems: 'center' }}  >

        <div className='col-md-6 text-center'>
          <div className='imgdiv forth'>
            <LazyImage src={`${static_img_url}/features/handloom.webp`} alt={'handloom'} />
          </div>
        </div>
        <div className='col-md-6'>
          <div className='h4 scolor mb-3'>Reviving Heritage, Empowering Weavers – " Every Purchase Keeps the Art of Maheshwar Alive. "</div>
          <div className='h6'>Every saree and dupatta you buy directly supports the skilled artisans who have preserved this craft for generations. Your purchase is not just a product—it’s a contribution to sustaining India’s rich handloom legacy.</div>
        </div>
      </div>
      
    </div>
  )
}

export default Features